import React from "react";
import { Chip, PostCard, Row } from "../HelperFunctions/HelperFunctions";
import { asList, statusColor } from "../../Utils/AdviserFormatters";

export default function AdviserDetailsCard({ adviser = {}, application = {} }) {
  const adviserStatuses = asList(adviser.status);
  const statusBackground = statusColor(adviserStatuses);
  return (
        <PostCard title="Adviser Details">
          <div className="smRatesAdviserDetails">
            <div className="smRow">
              <div className="smRowLabel Content-Small">Status</div>
              <div className="smChips">
                {adviserStatuses.length ? (
                  adviserStatuses.map((status) => (
                    <Chip
                      key={status}
                      style={{ background: statusBackground, color: "#fff" }}
                    >
                      {status}
                    </Chip>
                  ))
                ) : (
                  <span className="Content">-</span>
                )}
              </div>
            </div>
            <Row
              label="Trading Name"
              value={adviser.tradingName || adviser.tradingStyle || "-"}
            />
            <Row
              label="Trading Styles"
              value={asList(adviser.tradingStyles).join(", ") || "-"}
            />
            <Row
              label="Business Permissions"
              value={asList(application.businessAreas).join(", ") || "-"}
            />
            <Row
              label="AR Permissions"
              value={asList(application.ARBusinessAreas).join(", ") || "-"}
            />
          </div>
        </PostCard>
  );
}
